import BlSnackbarMv from './BlSnackbarMv.vue'

BlSnackbarMv.install = function(Vue) {
  Vue.component(BlSnackbarMv.name, BlSnackbarMv)
}

export default BlSnackbarMv
